const constant = {
    RADIO_TYPE:{
        ALL_DRIVERS: "all-drivers",
        SELECTED_DRIVERS: "selected-drivers",
        SELECT_ZONE_WISE: "select-zone-wise",
    },
    RADIO_LABELS: [
        { value: "selected-drivers", labelText: "Select drivers" },
        { value: "all-drivers", labelText: "All drivers at the terminal" },
        { value: "select-zone-wise", labelText: "Select zone-wise"},
    ],
    VALIDATION_ERROR: {
      REQUIRED: "* Required",
      DRIVER_REQUIRED: "* At least one driver selection is required",
      ZONE_REQUIRED: "* At least one zone is required",
    },
}

export default constant;